"use strict";
// Copyright (c) Microsoft Corporation.
// Licensed under the MIT license.
Object.defineProperty(exports, "__esModule", { value: true });
exports.telemetryKeys = exports.constants = exports.aadErrorCode = exports.permissionsKeys = exports.questionKeys = exports.descriptionMessageKeys = exports.logMessageKeys = void 0;
exports.logMessageKeys = {
    startExecuteDriver: "driver.aadApp.log.startExecuteDriver",
    successExecuteDriver: "driver.aadApp.log.successExecuteDriver",
    failExecuteDriver: "driver.aadApp.log.failExecuteDriver",
    startCreateAadApp: "driver.aadApp.log.startCreateAadApp",
    successCreateAadApp: "driver.aadApp.log.successCreateAadApp",
    successCreateAadAppandServicePrincipal: "driver.aadApp.log.successCreateAadAppandServicePrincipal",
    skipCreateAadApp: "driver.aadApp.log.skipCreateAadApp",
    startGenerateClientSecret: "driver.aadApp.log.startGenerateClientSecret",
    successGenerateClientSecret: "driver.aadApp.log.successGenerateClientSecret",
    skipGenerateClientSecret: "driver.aadApp.log.skipGenerateClientSecret",
    outputAadAppManifest: "driver.aadApp.log.outputAadAppManifest",
    successUpdateAadAppManifest: "driver.aadApp.log.successUpdateAadAppManifest",
    deleteAadAfterDebugging: "driver.aadApp.log.deleteAadAfterDebugging",
    insufficientPermission: "driver.aadApp.log.insufficientPermission",
};
exports.descriptionMessageKeys = {
    create: "driver.aadApp.description.create",
    update: "driver.aadApp.description.update",
};
exports.questionKeys = {
    aadAppIdTitle: "driver.aadApp.question.id.title",
    addAppIdValidation: "driver.aadApp.question.id.validation",
    aadAppSecretTitle: "driver.aadApp.question.secret.title",
    aadAppSecretValidation: "driver.aadApp.question.secret.validation",
    aadAppObjectIdTitle: "driver.aadApp.question.objectId.title",
    aadAppObjectIdValidation: "driver.aadApp.question.objectId.validation",
};
exports.permissionsKeys = {
    name: "Microsoft Entra App",
    owner: "Owner",
    noPermission: "No Permission",
    type: "M365",
};
exports.aadErrorCode = {
    permissionErrorCode: "CannotDeleteOrUpdateEnabledEntitlement",
    hostNameNotOnVerifiedDomain: "HostNameNotOnVerifiedDomain", // Using unverified domain in multi tenant scenario
    credentialInvalidLifetimeAsPerAppPolicy: "CredentialInvalidLifetimeAsPerAppPolicy",
    credentialTypeNotAllowedAsPerAppPolicy: "CredentialTypeNotAllowedAsPerAppPolicy",
    signInAudienceNotAllowedAsPerAppPolicy: "SignInAudienceNotAllowedAsPerAppPolicy",
};
exports.constants = {
    aadAppPasswordDisplayName: "default",
    defaultHelpLink: "https://aka.ms/teamsfx-actions/aadapp-create",
    sniHelpLink: "https://aka.ms/teams-toolkit-sni-guide",
    insufficientPermissionErrorMessage: "Insufficient privileges to complete the operation.",
};
exports.telemetryKeys = {
    newAadApp: "new-aad-app",
    userInputAadApp: "user-input-aad-app",
    insufficientPermissionAadApp: "insufficient-permission-aad-app",
    isNewAadSchema: "is-new-aad-schema",
};
//# sourceMappingURL=constants.js.map